import { Auth } from 'aws-amplify'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { getUserInfo } from '../pages/api/sso/api'

export const useAuthDefender = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSuccess?: (user: any) => void | Promise<void>,
  failedRedirectLink: string = '/signin',
  authenticated = true,
) => {
  const router = useRouter()
  const { isReady } = router
  useEffect(() => {
    if (!isReady) {
      return
    }

    const checkSignIn = async () => {
      let user
      const isSSOUser = localStorage.getItem('sso') === 'true'
      try {
        user = isSSOUser ? await getUserInfo() : await Auth.currentAuthenticatedUser()
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        user = null
      }
      if (authenticated) {
        if (user) {
          onSuccess && onSuccess(user)
        } else {
          router.push({ pathname: failedRedirectLink })
        }
      } else {
        if (user) {
          router.push({ pathname: failedRedirectLink })
        } else {
          onSuccess && onSuccess(user)
        }
      }
    }

    checkSignIn()
  }, [isReady])
}
